import type { CalendarConversationInviteeType } from '@axiom/validation';

/**
 * Sorts calendar conversation invitees with the following priority:
 * 1. Candidates appear first
 * 2. Within candidates, sorted by contact full name (descending)
 * 3. Within candidates with same name, sorted by contact email (descending)
 * 4. Non-candidates follow, sorted by contact full name (descending)
 * 5. Non-candidates with same name, sorted by contact email (descending)
 */
const sortInviteesByPriority = (
  invitees: CalendarConversationInviteeType[]
): CalendarConversationInviteeType[] => {
  return [...invitees].sort((a, b) => {
    const aIsCandidate = Boolean(a.candidate);
    const bIsCandidate = Boolean(b.candidate);

    // If one is a candidate and the other isn't, candidate comes first
    if (aIsCandidate && !bIsCandidate) {
      return -1;
    }
    if (!aIsCandidate && bIsCandidate) {
      return 1;
    }

    // Both are candidates or both are non-candidates, sort by name then email
    const aName = a.contact?.fullName ?? '';
    const bName = b.contact?.fullName ?? '';

    if (aName !== bName) {
      return bName.localeCompare(aName); // Descending order
    }

    // Names are equal, sort by email
    const aEmail = a.contact?.email ?? '';
    const bEmail = b.contact?.email ?? '';

    return bEmail.localeCompare(aEmail); // Descending order
  });
};

export const InterviewGridUtil = {
  sortInviteesByPriority,
};
